import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { paymentThresholdActionType } from '../actions/actionTypes';
import { updateFilterReducer, updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'PaymentThresholdFilterList';

const logPtListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});
const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

function PaymentThresholdFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    case paymentThresholdActionType.UPDATE_PT_COLUMN_CONFIG:
      return {
        ...state,
        listSortOptions: action.data.sortOptions,
        listColumnOrder: action.data.columnOrder,
      };
    case paymentThresholdActionType.UPDATE_PT_FILTER_CONFIG:
      return {
        ...state,
        ...updateFilterReducer(action),
      };
    case paymentThresholdActionType.REMOVE_PT_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case paymentThresholdActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    default:
      return null;
  }
}

function PaymentThresholdFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    /// log request
    case paymentThresholdActionType.LOG_PT_LIST_REQUEST:
      return logPtListReq(state, action);
      // log error
    case paymentThresholdActionType.GET_PT_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
      // store response
    case paymentThresholdActionType.GET_PT_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case paymentThresholdActionType.GET_PT_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
      // Reset store
    case paymentThresholdActionType.RESET_PT_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case paymentThresholdActionType.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}

const PaymentThresholdFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = PaymentThresholdFilterListConfig(state, action);
  const stateReqRes = PaymentThresholdFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default PaymentThresholdFilterList;
